<template>
    <div id="partners" class="pagetext">
        <div id="partnercontainer">
            <h2>Interested in using this site, but not sure where to start?
            <br>
            Been using this site, but want to get more out of it?
            <br></h2>
        </div>
            <h2>Get in touch with one of our student curriculum partners!</h2>
        <br>
        <partner-search></partner-search>
    </div>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import PartnerSearch from '@/components/PartnerSearch.vue';

export default {
    components: {
        PartnerSearch,
    },
};
</script>

<style scoped>

</style>
